export default "__VITE_ASSET__fRhtIGfz__"